import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useMergeState } from '../../../../utils/hooks';
import NormalButton from '../../buttons/normalButton';
import NormalInput from '../../inputs/normalInput';
import NormalSelect from '../../selects/normalSelect';
import {
  createUser, getForm, getRoleOption, getSchema,
} from './helper';
import { isValidEmail } from '../../../../utils';

import './style.scss';

const CreateNewUserModal = (props) => {
  const [state, setState] = useMergeState({
    loading: false,
  });

  const schema = getSchema();
  const form = getForm(schema);

  const roleOption = getRoleOption();

  const onCancel = () => {
    props.onCancel();
  };

  const onCreate = (data) => {
    props.onCreate(data);
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    form.clearErrors('email');
    if (!isValidEmail(form.getValues('email'))) {
      form.setError('email', { message: 'Email format is incorrect.' }, { shouldFocus: true });
      return;
    }
    setState({ loading: true });
    const newUser = await createUser(form.getValues());
    if (newUser?.isSuccess) {
      const { user } = newUser;
      onCreate({
        key: user.id,
        id: user.id,
        username: `${user?.firstName || '--'} ${user?.lastName || '--'}`,
        email: user?.email || '--',
        createdAt: user?.createdAt || '--',
        createdBy: user?.createdBy ? `${user?.createdBy?.firstName || '--'} ${user?.createdBy?.lastName || '--'}` : '--',
      });
    } else {
      const errMsg = newUser.message.includes('already existed') ? 'Email address existed. Please try another.' : newUser.message;
      form.setError('email', { message: errMsg }, { shouldFocus: true });
      setState({ loading: false });
      return;
    }
    setState({ loading: false });
    onCancel();
  };

  useEffect(() => {
    form.reset({
      firstName: '',
      lastName: '',
      email: '',
      role: undefined,
    });
  }, [props.visible]);

  return (
    <Modal
      className="create-user-modal"
      title="Create new user"
      visible={props.visible}
      onCancel={onCancel}
      maskClosable={props.maskClosable}
      footer={[
        <NormalButton
          key="submit"
          text="Create new user"
          type="primary"
          loading={state.loading}
          disabled={!form?.formState?.isValid}
          onClick={onSubmit}
        />,
      ]}
    >
      <form onSubmit={onSubmit}>
        <NormalInput
          name="firstName"
          title="First name"
          isRequired
          isUseForm
          control={form?.control}
          placeholder="First name"
        />
        <NormalInput
          className="mt-10"
          name="lastName"
          title="Last name"
          isRequired
          isUseForm
          control={form?.control}
          placeholder="Last name"
        />
        <NormalInput
          className="mt-10"
          name="email"
          title="Email address"
          isRequired
          isUseForm
          control={form?.control}
          placeholder="Email address"
          errMsg={form?.formState?.errors?.email?.message}
        />
        <NormalSelect
          className="mt-10"
          name="role"
          title="Role"
          isRequired
          isUseForm
          control={form?.control}
          placeholder="Role"
          options={roleOption}
        />
      </form>
    </Modal>
  );
};

CreateNewUserModal.defaultProps = {
  visible: false,
  maskClosable: false,

  onCancel: () => {},
  onCreate: () => {},
};

CreateNewUserModal.propTypes = {
  visible: PropTypes.bool,
  maskClosable: PropTypes.bool,

  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
};

export default CreateNewUserModal;
